<template>
  <div>
    <div class="header-row">
      <div class="title">
        <span class="label">创作台：</span>
        <el-input v-model="scriptInfo.scriptName"></el-input>
        <el-tag v-if="!editingSaved" type="warning">未保存</el-tag>
      </div>

      <div class="btns">
        <el-button type="primary" :loading="globalSaveLoading" @click="onScriptTableSave">保存</el-button>
        <el-button @click="onGlobalOptimize">脚本智能优化</el-button>
        <el-button @click="onScriptMaterialMerge">一键混剪</el-button>
      </div>
    </div>

    <div class="table-wrapper">
      <!--  class="common-el-table-styles" -->
      <el-table :data="tableData" row-key="uid" ref="tableRef" border style="width: 100%">
        <el-table-column width="55">
          <template>
            <span class="drag-btn">
              <i class="el-icon-rank"></i>
            </span>
          </template>
        </el-table-column>
        <el-table-column label="NO." width="60">
          <template slot-scope="{ $index }">{{ $index + 1 }}</template>
        </el-table-column>
        <el-table-column prop="time_range" label="时间区间" width="120"> </el-table-column>
        <el-table-column prop="shot_title" label="分镜标题" width="140">
          <template slot-scope="{ row, $index }">
            <el-input
              type="textarea"
              rows="4"
              @blur="row.titleEdit = false"
              v-if="row.titleEdit"
              v-model="row.shot_title"
              placeholder="请输入分镜标题"
            ></el-input>
            <div class="edit-text" v-else @click="onEditTextClick($index, 'titleEdit', $event)">
              <span> {{ row.shot_title || '请填写' }}</span>
              <span class="el-icon-edit"></span>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="visual_core" label="画面描述" width="220">
          <template slot-scope="{ row, $index }">
            <el-input
              type="textarea"
              rows="4"
              @blur="row.descEdit = false"
              v-if="row.descEdit"
              v-model="row.visual_core"
              placeholder="请输入画面描述"
            ></el-input>
            <div v-else class="edit-text" @click="onEditTextClick($index, 'descEdit', $event)">
              <span>{{ row.visual_core || '请填写' }}</span>
              <span class="el-icon-edit"></span>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="dialogue" label="台词" width="220">
          <template slot-scope="{ row, $index }">
            <el-input
              type="textarea"
              rows="4"
              @blur="row.dialogueEdit = false"
              v-if="row.dialogueEdit"
              v-model="row.dialogue"
              placeholder="请输入台词"
            ></el-input>
            <div v-else class="edit-text" @click="onEditTextClick($index, 'dialogueEdit', $event)">
              <span> {{ row.dialogue || '请填写' }}</span>
              <span class="el-icon-edit"></span>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="content_narrative_focus" label="叙事重点" width="220">
          <template slot-scope="{ row, $index }">
            <el-input
              type="textarea"
              rows="4"
              @blur="row.focusEdit = false"
              v-if="row.focusEdit"
              v-model="row.content_narrative_focus"
              placeholder="请输入叙事重点"
            ></el-input>
            <div v-else class="edit-text" @click="onEditTextClick($index, 'focusEdit', $event)">
              <span>{{ row.content_narrative_focus || '请填写' }}</span>
              <span class="el-icon-edit"></span>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="emotion_atmosphere" label="内容标签" width="220">
          <template slot-scope="{ row, $index }">
            <el-input
              type="textarea"
              rows="4"
              @blur="row.emoEdit = false"
              v-if="row.emoEdit"
              v-model="row.emotion_atmosphere"
              placeholder="请输入情感氛围"
            ></el-input>
            <div v-else class="edit-text" @click="onEditTextClick($index, 'emoEdit', $event)">
              <span>{{ row.emotion_atmosphere || '请填写' }}</span>
              <span class="el-icon-edit"></span>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="key_elements" label="关键元素" width="120">
          <template slot-scope="{ row, $index }">
            <el-input
              type="textarea"
              rows="4"
              @blur="row.keywordsEdit = false"
              v-if="row.keywordsEdit"
              v-model="row.key_elements"
              placeholder="关键要素使用逗号分隔"
            ></el-input>
            <div v-else class="edit-text" @click="onEditTextClick($index, 'keywordsEdit', $event)">
              <span>{{ row.key_elements || '请填写' }}</span>
              <span class="el-icon-edit"></span>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="materials" label="素材池（按匹配度排序）" width="490">
          <template slot-scope="{ row, $index }">
            <template v-if="matchMaterialLoading">
              <span class="el-icon-loading"></span>
              <span>匹配素材中...</span>
            </template>
            <template v-else>
              <div class="material-list" v-if="row.materials && row.materials.length">
                <ShotItem
                  v-model="row.materialCheckedId"
                  v-for="video in row.materials.slice(0, 3)"
                  :key="video.id"
                  :video="video"
                ></ShotItem>
                <el-button type="text" @click="showMoreMaterials(row, $index)">更多...</el-button>
              </div>
              <span v-else>暂未匹配到素材</span>
            </template>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="187">
          <template slot-scope="{ row, $index }">
            <el-button type="text" :loading="row.shotOptimizeLoading" @click="startScriptShotOptimize(row, $index)">分镜优化</el-button>
            <el-button type="text" :loading="row.shotRematchLoading" @click="getShotMaterialItems(row, $index)">重新匹配</el-button>
            <el-button type="text" @click="onShotItemRemove($index)">删除</el-button>

            <div class="match-threshold">
              <el-tooltip effect="dark" content="数值越高，匹配数量越少，但准确性越高" placement="top">
                <span class="threshold">片段匹配阈值：{{ row.matchThreshold }}%</span>
              </el-tooltip>

              <el-slider v-model="row.matchThreshold" @change="getShotMaterialItems(row, $index)" :min="1" :max="100" :step="1"></el-slider>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <div class="add-btn">
      <el-button style="width: 100%" @click="onAddShot">+ 添加分镜</el-button>
    </div>

    <!-- 分镜素材列表弹窗 -->
    <ShotMaterialListModal
      :visible.sync="shotMaterialModalVisible"
      :list="shotMaterialList"
      :value="currEditRow.materialCheckedId"
      show-close
      :title="`选择匹配素材（分镜${currentMaterialRowIndex + 1}）`"
      width="660px"
      @change="onShotMaterialChange"
    ></ShotMaterialListModal>

    <!-- 一键混剪 -->
    <FullVideoPreviewModal
      :visible.sync="videoPreviewModalVisible"
      :segment-list="tableData"
      :script-info="scriptInfo"
      show-close
      title="一键成片预览"
      width="560px"
      @confirm="onCutConfirm"
    ></FullVideoPreviewModal>

    <!-- 编辑时的脚本优化 -->
    <EditableScriptOptimizeModal
      :visible.sync="scriptOptimizeModalVisible"
      :step="scriptOptimizeStep"
      :shots="lagecyGlobalOptimizedScript"
      :new-shots="newGlobalOptimizedScript"
      v-model="optimizationText"
      show-close
      title="脚本智能优化"
      width="780px"
      @cancel="onGlobalOptimizeCancel"
    >
      <template #confirm-btn>
        <template v-if="scriptOptimizeStep === 1">
          <el-button type="primary" icon="el-icon-position" @click="startGlobalOptimize(matchByScript)" :loading="globalOptimizeLoading"
            >开始优化
          </el-button>
        </template>

        <template v-if="scriptOptimizeStep === 2">
          <el-button v-if="optimizeFlag === OPTIMIZE_FLAG.GLOBAL" @click="goBack">返回修改</el-button>
          <el-button type="primary" icon="el-icon-check" @click="onGlobalOptimizeApply(getShotMaterialItems, matchByScript)"
            >应用所选</el-button
          >
        </template>
      </template>
    </EditableScriptOptimizeModal>
  </div>
</template>

<script setup>
import { ref, nextTick, onActivated, onMounted, onDeactivated, onUnmounted } from 'vue'
import store from '@/store/index.js'
import { clone } from '@/common/js/just.js'
import { Message } from 'view-design'
import { useRoute, useRouter } from 'vue-router/composables'
import Sortable from 'sortablejs'
import { parseTimeRange, formatMMSS, getKeywordList, getDuration } from './utils.js'
import { OPTIMIZE_FLAG, useScriptTableInit, useEditOptimize, useScriptAddAndSave } from './hooks/useEdit.js'
import FullVideoPreviewModal from './components/full-video-preview.vue'
import EditableScriptOptimizeModal from './components/editable-script-optimize.vue'
import ShotMaterialListModal from './components/shot-material-list.vue'
import ShotItem from './components/shot-video-item.vue'
import { scriptCut } from '@/api/material.model.js'

const beforeUnloadHandler = (event) => {
  event.preventDefault()
  event.returnValue = '您有未保存的更改，确定要离开吗？'
  return '您有未保存的更改，确定要离开吗？'
}

const route = useRoute()
const router = useRouter()
const tableRef = ref(null)
const editScriptId = ref(null)
const createScriptId = ref(null)
const videoPreviewModalVisible = ref(false)

const {
  tableData,
  scriptInfo,
  matchThreshold,
  shotMaterialModalVisible,
  matchMaterialLoading,
  currEditRow,
  currentMaterialRowIndex,
  shotMaterialList,
  matchByScript,
  makeTableByParams,
  getScriptDetail,
  getSettingList,
  getShotMaterialItems,
  showMoreMaterials,
  onEditTextClick,
  onShotMaterialChange
} = useScriptTableInit()

const {
  optimizeFlag,
  scriptOptimizeModalVisible,
  globalOptimizeLoading,
  optimizationText,
  scriptOptimizeStep,
  lagecyGlobalOptimizedScript,
  newGlobalOptimizedScript,
  onGlobalOptimize,
  startGlobalOptimize,
  onGlobalOptimizeApply,
  goBack,
  onGlobalOptimizeCancel,
  startScriptShotOptimize
} = useEditOptimize(tableData, scriptInfo)

const { editingSaved, savedScriptJSON, globalSaveLoading, onAddShot, onSaveScript, onShotItemRemove } = useScriptAddAndSave(
  tableData,
  scriptInfo,
  matchThreshold
)

/**
 * @description: 获取脚本详情
 * @return {*}
 */
async function init() {
  const { scriptContent, scriptId } = route.params
  // scriptId如果是时间戳且小于3天则代表的是新建脚本，为了满足每新建一个脚本就新建一个页签的需要
  // 如果scriptId是正常的脚本id，则获取详情进行编辑，不同的脚本也需要新建不同页签
  const isCreate = Date.now() - scriptId < 1000 * 60 * 60 * 24 * 3

  tableData.value = []
  await getSettingList()

  if (isCreate) {
    createScriptId.value = scriptId
    editScriptId.value = null
    if (scriptContent) {
      makeTableByParams(scriptContent)
    }
  } else {
    // 同一个脚本编辑时不做重复请求，保留原有数据
    if (scriptId === editScriptId.value) return
    editScriptId.value = Number(scriptId)
    createScriptId.value = null

    if (scriptId) {
      await getScriptDetail(scriptId)
    }
  }

  initTableRowDragDrop()

  // 字符串对比是否有变更
  savedScriptJSON.value = clone({
    name: scriptInfo.value.scriptName,
    content: tableData.value
  })
}
/**
 * @description: 初始化表格行拖拽
 * @return {*}
 */
function initTableRowDragDrop() {
  nextTick(() => {
    Sortable.create(tableRef.value.$el.querySelector('.el-table__body-wrapper tbody'), {
      handle: '.drag-btn',
      onEnd: ({ newIndex, oldIndex }) => {
        const currRow = tableData.value.splice(oldIndex, 1)[0]
        tableData.value.splice(newIndex, 0, currRow)

        // 重新计算时间区间：保持每行原有时长，按新顺序连续排布
        let cursor = 0
        tableData.value.forEach((row) => {
          const parsed = parseTimeRange(row.time_range)
          const duration = parsed ? Math.max(0, parsed.end - parsed.start) : 5
          const start = cursor
          const end = cursor + duration
          row.time_range = `${formatMMSS(start)}-${formatMMSS(end)}`
          cursor = end
        })
      }
    })
  })
}

function onScriptMaterialMerge() {
  const materialChecked = tableData.value.every((item) => item.materialCheckedId)
  if (!materialChecked) return Message.error('每个分镜都需要选择素材')

  videoPreviewModalVisible.value = true
}

async function onScriptTableSave() {
  const scriptId = await onSaveScript()
  if (createScriptId.value) {
    const navList = store.state.tagNavList
    // 防止脚本编辑出现多个nav tag, 根据params传参时清除掉之前的页面tag
    const newList = navList.filter((i) => {
      return i.params.scriptId !== createScriptId.value
    })
    store.commit('setTagNavList', newList)

    router.replace({
      name: 'materialscriptedit',
      params: {
        scriptId: `${scriptId}`
      }
    })
  }
}

async function onCutConfirm({ title, aiAnalysisEnabled }) {
  const scriptId = await onSaveScript(false)
  if (!scriptId) return Message.error('脚本混剪失败')
  const duration = getDuration(tableData.value)
  const shots = tableData.value.map((item) => {
    const key_elements = getKeywordList(item.key_elements)
    return {
      time_range: item.time_range,
      shot_title: item.shot_title,
      visual_core: item.visual_core,
      dialogue: item.dialogue,
      content_narrative_focus: item.content_narrative_focus,
      emotion_atmosphere: item.emotion_atmosphere,
      key_elements,
      videos: item.materials.map((v) => {
        return { ...v, selected: v.id === item.materialCheckedId }
      })
    }
  })
  const scriptContent = {
    title,
    duration,
    shot_count: shots.length,
    shots
  }
  scriptCut({
    scriptId,
    scriptContent,
    aiAnalysisEnabled
  }).then((data) => {
    if (data) {
      Message.success('正在视频拼接中，请稍等...')
      videoPreviewModalVisible.value = false
      router.replace({ name: 'materialscriptlist', params: { refresh: true } })
    }
  })
}
onMounted(init)
onActivated(() => {
  window.addEventListener('beforeunload', beforeUnloadHandler)
  // init()
})
onDeactivated(() => {
  window.removeEventListener('beforeunload', beforeUnloadHandler)
})
onUnmounted(() => {
  window.removeEventListener('beforeunload', beforeUnloadHandler)
})
</script>

<style scoped lang="scss">
@import '~common/styles/element-ui/variables.scss';
.header-row {
  display: flex;
  justify-content: space-between;
  padding-top: 8px;

  .title {
    display: flex;
    align-items: center;

    .label {
      width: 80px;
      font-weight: 700;
    }
    .el-tag {
      margin-left: 10px;
    }
  }
}

.table-wrapper {
  margin-top: 16px;

  .edit-text {
    width: 100%;
    cursor: pointer;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .material-list {
    display: flex;
    flex-wrap: wrap;
  }

  ::v-deep .match-threshold {
    margin-top: 10px;
    .el-slider__runway {
      margin: 6px 0;
    }
  }
}

.add-btn {
  margin-top: 10px;
}
</style>
